import { useSearchParams, Link } from "react-router-dom";
import { Check, AlertCircle } from "lucide-react";

const GOLD = "#C9A84C";

export default function Desinscription() {
  const [params] = useSearchParams();
  const ok = params.get("ok") === "1";
  return (
    <div className="min-h-screen bg-brand-ink text-white pt-32 pb-24" data-testid="desinscription-page">
      <div className="max-w-[640px] mx-auto px-6 text-center">
        {ok ? <Check className="mx-auto mb-6" size={36} style={{ color: GOLD }} /> : <AlertCircle className="mx-auto mb-6" size={36} style={{ color: GOLD }} />}
        <h1 className="font-serif text-3xl md:text-4xl mb-4">{ok ? "Vous êtes désinscrit." : "Ce lien de désinscription n'est pas valide."}</h1>
        <p className="text-white/60 leading-relaxed">
          {ok ? "Vous ne recevrez plus les emails automatiques de l'Académie AETHERIS. Vos chiffres, eux, ne changent pas : vous restez le bienvenu." : "Écrivez à gestion.svh@serenite-essence.fr et nous traiterons votre demande à la main."}
        </p>
        <Link to="/" className="inline-block mt-8 text-xs uppercase tracking-[0.2em] underline underline-offset-4" style={{ color: GOLD }}>Retour au site</Link>
      </div>
    </div>
  );
}
